import React from "react";
import { QuestionCircleOutlined } from "@ant-design/icons";

const ConfirmationPopup = ({ confirmation, setConfirmation,handleDelete }) => {
  return (
    <div>
      {confirmation && (
        <div className="popup-overlay">
          <div className="confirmation_popup_container">
            <QuestionCircleOutlined />
            <h3>Heads up</h3>
            <p>Are you sure?</p>
            <div>
              <button
                className="cancel_btn"
                onClick={() => setConfirmation(false)}
              >
                Cancel
              </button>
              <button className="continue_btn"
               type="button"
               onClick={handleDelete}
              >Continue</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmationPopup;
